import React, {useState, useEffect, forwardRef, useRef} from 'react';
import {useNavigate} from "react-router-dom";

import {
    CloseOutlined,
    SmileOutlined,
    MenuOutlined,
    UploadOutlined,
    UserOutlined,
    VideoCameraOutlined,
} from "@ant-design/icons";
import {Button, Layout, Menu} from "antd";

import MenuContainer from "./Menu";

const { Sider } = Layout;

const SiderMobileContainer = (props) => {

    const {collapsed, setCollapsed} = props;

    const [shortVideoIf, setIShortVideoIf] = useState(false);
    const [shortVideoUrl, setShortVideoUrl] = useState('');

    const menuRef = useRef();

    const toShortVideo = (url) => {
        setCollapsed(true);
        window.location.href = shortVideoUrl
    }

    useEffect(() =>{
        let lawOtherCfg = window.lawOtherCfg;
        // let lawOtherCfg = {
        //     vurl: "https://sp.benlux.fun/"
        // }

        if(lawOtherCfg){
            setIShortVideoIf(true)
            setShortVideoUrl(lawOtherCfg.vurl);
        }
    }, [])

    return (
        <Sider
            className={collapsed ? "container_sider left_visibility" : "container_sider"}
            width={200}
            trigger={null}
            breakpoint="md"
            collapsible
            collapsedWidth={60}
            collapsed={false}
        >
            <Button
                className="header_mobile_menu_btn"
                type="text"
                size="large"
                icon={<CloseOutlined style={{fontSize: '24px'}} />}
                onClick={() => setCollapsed(!collapsed)}
            />
            <MenuContainer ref={menuRef} collapsed={collapsed} setCollapsed={setCollapsed} collapsedFlag={false}>
                {
                    shortVideoIf
                        ? <div className="other_cell"
                               onClick={toShortVideo}
                               style={{
                                   paddingLeft: '28px',
                                   paddingTop: '8px',
                                   fontSize: '20px',
                                   opacity: '0.6'
                               }}
                        >
                            <VideoCameraOutlined key='VideoCameraOutlined' />
                            <span
                                style={{
                                    marginLeft: '12px',
                                    fontSize: '16px'
                                }}
                            >Short Video</span>
                        </div>
                        : ''
                }

            </MenuContainer>
            <div className="ant-drawer" style={{display: collapsed? 'none': 'block'}} onClick={() => setCollapsed(!collapsed)}>
                <div className="ant-drawer-mask"></div>
            </div>
        </Sider>
    )
}

export default SiderMobileContainer;